// extracted by mini-css-extract-plugin
export default {"wrapperMain":"MainLayout_wrapperMain__2qt0b","wrapperRoot":"MainLayout_wrapperRoot__TBLTB"};